module.exports = __webpack_public_path__ + "img/story007@2x.18144223.webp";